import { render, staticRenderFns } from "./ExtraChips.vue?vue&type=template&id=0c4a4981&"
import script from "./ExtraChips.vue?vue&type=script&lang=js&"
export * from "./ExtraChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports